'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkSkuBrowserByCategoryTabs.module.css';

export function DevlinkSkuBrowserByCategoryTabs({
  as: _Component = _Builtin.Section,
  showSectionTitle = true,
  sectionTitle = 'Heading',
  showTabMenu = true,
  tabMenu,
  skuGrids,
}) {
  return (
    <_Component
      grid={{
        type: 'section',
      }}
      tag="section"
    >
      <_Builtin.HtmlEmbed value="%3Cstyle%3E%0A%5Bsku-category-tab-menu%5D%3Alast-child%7B%0A%20%20padding-right%3A%2016px%3B%0A%7D%0A%2F*%20Hide%20scrollbar%20for%20Chrome%2C%20Safari%20and%20Opera%20*%2F%0A%5Bremove-scrollbar%5D%3A%3A-webkit-scrollbar%20%7B%0A%20%20display%3A%20none!important%3B%0A%20%20-webkit-appearance%3A%20none!important%3B%0A%20%20width%3A%200!important%3B%0A%20%20height%3A%200!important%3B%0A%7D%0A%0A%2F*%20Hide%20scrollbar%20for%20IE%2C%20Edge%20and%20Firefox%20*%2F%0A%5Bremove-scrollbar%5D%20%7B%0A%20%20-ms-overflow-style%3A%20none!important%3B%20%20%2F*%20IE%20and%20Edge%20*%2F%0A%20%20scrollbar-width%3A%20none!important%3B%20%20%2F*%20Firefox%20*%2F%0A%20%20%0A%7D%0A%3C%2Fstyle%3E" />
      {showSectionTitle ? (
        <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'lg')} tag="div">
          <_Builtin.Heading className={_utils.cx(_styles, 'txt-header-sm')} tag="h3">
            {sectionTitle}
          </_Builtin.Heading>
          <_Builtin.Block className={_utils.cx(_styles, 'tiny-1')} tag="div" />
        </_Builtin.Block>
      ) : null}
      {showTabMenu ? (
        <_Builtin.Block className={_utils.cx(_styles, 'ht-sku-category-tab-menu-container')} tag="div" remove-scrollbar="">
          <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'lg')} tag="div">
            <_Builtin.Block className={_utils.cx(_styles, 'ht-sku-category-tab-menu')} tag="div" sku-category-tab-menu="" data-testid="tab-container">
              {tabMenu}
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      ) : null}
      <_Builtin.Block className={_utils.cx(_styles, 'ht-sku-category-grid-section')} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'lg')} tag="div">
          <_Builtin.Block className={_utils.cx(_styles, 'ht-sku-category-grids')} tag="div">
            {skuGrids}
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
